<footer class="pt-5 text-muted text-center text-small">
  <p class="mb-1">&copy; {{currentYear}} PWV Hauenstein</p>
  <ul class="list-inline">
    <li class="list-inline-item"><a routerLink="datenschutz" routerLinkActive="active">Datenschutz</a></li>
    <li class="list-inline-item"><a routerLink="impressum" routerLinkActive="active">Impressum</a></li>
  </ul>
</footer>